import React from "react";
import { pageNotFound } from "../../assets";
import useDeviceType from "../../custom-hooks/DeviceType";
import { Typography } from "@mui/material";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";

const NoRouteFoundScreen = () => {
  const deviceType = useDeviceType();
  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0 flex justify-center items-center flex-col"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <img
        src={pageNotFound}
        alt="page-not-found"
        className={deviceType === "mobile" ? "w-[80%]" : "w-[50%]"}
      />
      <Typography
        className="cursor-pointer pt-6 text-xl font-bold"
        // onClick={() => navigate("/login")}
      >
        Page Not Found. Please check the URL or return to the home page.
      </Typography>
    </WrapperCard>
  );
};

export default NoRouteFoundScreen;
